module.exports = __webpack_public_path__ + "img/map.0fcce231.svg";